import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import Footer from '../../component/Footer'
import Header from '../../component/Header'
import { apiwebUrl } from '../../utils';

function Categoias() {
  const [listarCategoria, setListarcategorias] = useState([]);
  const [nombre,setNombre] = useState("");
  const [descripcion,setDescripcion] = useState("");
  const traerServi = async () => {
    const url = apiwebUrl + "categorias.php"

    const response = await fetch(url)
    const data = await response.json()
    setListarcategorias(data)
  }
  const mostrarTabla = () => {
    return (
      <div className='table-responsive'>
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Codigo</th>
              <th scope="col">Nombre</th>
              <th scope="col">Descripcion</th>
              <th scope="col" className='text-end'>Editar</th>
              <th scope="col" className='text-end'>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {
              listarCategoria.map(item => (
                <tr className="table-active" key={item.idcategoria}>
                  <th scope="row">{item.idcategoria}</th>
                  <td>{item.nombre}</td>
                  <td>{item.descripcion}</td>
                  <td className='text-end'><i className="fa-solid fa-pen text-info"></i></td>
                  <td className='text-end'><i className="fa-solid fa-trash-can text-danger"
                    onClick={() => eliminar(item)}
                  ></i></td>
                </tr>

              ))
            }
          </tbody>
        </table>
      </div>

    )
  }

  const eliminar = (item) => {
   
  }


  useEffect(() => {
    traerServi()
  }, [])


  return (
    <Fragment>
      <Header />
      <div className='col-8 m-auto mt-5'>
        <h3 className='fw-light letra__ mb-5'>Tabla categoria</h3>
        <div className='d-flex justify-content-end'>
          <button className='btn btn-success text-capitalize'
            data-bs-toggle="modal" data-bs-target="#exampleModal"
          >Agegar categoria <i className="fa-solid fa-circle-plus fs-5"></i></button>
        </div>
        {
          mostrarTabla()
        }
      </div>

      <Footer />

      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label>Ingrese Nombre:</label>
                  <input type="text" className="form-control" placeholder='Ingrese Nombre' 
                  value={nombre}
                  onChange={(e => setNombre(e.target.value))}
                  />
                </div>
                <div className="form-group">
                  <label>Descripcion:</label>
                  <textarea className="form-control"
                  value={descripcion}
                  onChange={(e => setDescripcion(e.target.value))}
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary text-capitalize" data-bs-dismiss="modal">Cerrar</button>
              <button type="button" className="btn btn-primary text-capitalize">Guardar cambios</button>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  )
}

export default Categoias